export var emailErrorMessagesMixin = {
    computed: {
        emailErrorMessages: function emailErrorMessages() {
            var propertyName = 'email';
            var errors = [];
            if (!this.$v[propertyName].$dirty) return errors;
            !this.$v[propertyName].required && errors.push('Debes ingresar un correo electrónico'),
            // !this.$v[propertyName].email && errors.push('El correo ingresado no existe')
            !this.$v[propertyName].noSpecialChars && errors.push('No puede ingresar caracteres especiales');
            !this.$v[propertyName].emailValidate && errors.push('Ingrese un email válido');
            return errors;
            // return [
            //     !this.$v[propertyName].$dirty || this.$v[propertyName].required || 'Debes ingresar un correo electrónico',
            //     !this.$v[propertyName].$dirty || this.$v[propertyName].email || 'El correo ingresado no existe',
            //     !this.$v[propertyName].$dirty || this.$v[propertyName].emailValidate || 'Ingrese un email válido'
            // ]
            // .filter(val => typeof(val) === 'string')
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/email-error-messages.js
// module id = ./src/mixins/email-error-messages.js
// module chunks = 34